import ProviderSectionContainer, {
  PROVIDER_SECTION_IDS,
} from 'app/ProviderDetails/ProviderSectionContainer'
import {
  monthNames,
  isValidHttpUrl,
  formattedURL,
} from 'app/ProviderDetails/utils'
import styles from './index.module.scss'

type PublicationsProps = {
  providerDetails: Provider
}

const Publications: React.FC<PublicationsProps> = ({ providerDetails }) => {
  const { achievements } = providerDetails
  const { publications, accomplishments, awards } = achievements || {}

  const renderAchievement = (providedByText: string) => {
    if (!providedByText || providedByText === '-') {
      return null
    }

    if (isValidHttpUrl(providedByText)) {
      return (
        <>
          {`, `}
          <a href={providedByText}>{formattedURL(providedByText)}</a>
        </>
      )
    }

    return <span>{`, ${providedByText}`}</span>
  }

  return (
    !!(publications?.length || accomplishments?.length || awards?.length) && (
      <ProviderSectionContainer
        heading="Publications, accomplishments and awards"
        id={PROVIDER_SECTION_IDS.PUBLICATIONS}
      >
        <div className={styles.publication_content}>
          {publications.map(({ name, year, month, providedBy }, index) => (
            <div
              key={`${name} ${year} ${index}`}
              className={styles.publication_content_row}
            >
              <span className="~font-gibson ~font-medium ~text-black ~text-lg">
                {`${name} `} {month ? `— ${monthNames[month]} ` : ''}
                {year} {renderAchievement(providedBy)}
              </span>
            </div>
          ))}

          {awards.map(({ name, year, month, providedBy }, index) => (
            <div
              key={`${name} ${year} ${index}`}
              className={styles.publication_content_row}
            >
              <span className="~font-gibson ~font-medium ~text-black ~text-lg">
                {`${name} `}{' '}
                {month && year ? `- ${monthNames[month]} ${year}` : `- ${year}`}
                {renderAchievement(providedBy)}
              </span>
            </div>
          ))}

          {accomplishments.map(({ name, year, month, providedBy }, index) => (
            <div
              key={`${name} ${month} ${index}`}
              className={styles.publication_content_row}
            >
              <span className="~font-gibson ~font-medium ~text-black ~text-lg">
                {`${name} `} {month && year ? `- ${monthNames[month]} ` : ''}
                {year} {renderAchievement(providedBy)}
              </span>
            </div>
          ))}
        </div>
      </ProviderSectionContainer>
    )
  )
}

export default Publications
